export default "__VITE_ASSET__af160a29__"